/* ============================================================================
   KARAAT — bundle option grouping  (2026-11-02)
   Bundle products name their options "<Product> – <Label>" (e.g. "Ellipse Diamond
   Ring – Metal", "Ellipse Diamond Ring – Ring size"); the same names are what the
   cart/order show, so each choice stays tied to its piece. On the page, VO Product
   Options (#bcpo) renders all Shopify options first and its virtual options after,
   so the two products' choices end up interleaved. This regroups them: one product
   name as a small heading, then that product's choices with the short label only.
   Only acts when 2+ distinct product prefixes are found, so normal products are
   untouched. Re-runs if VO re-renders.
   ========================================================================== */
(function () {
  var SEP = ' – ';

  // Snapshot of #bcpo's current order + labels; lets a re-run bail out without
  // touching the DOM (its own moves would otherwise re-trigger the observer).
  function signature(root) {
    return Array.prototype.map.call(root.children, function (el) {
      if (el.classList.contains('kb-bundle-group__title')) return 'h:' + el.textContent;
      var t = el.querySelector('.bcpo-title');
      return t ? (t.getAttribute('data-kb-full') || '') + '|' + t.textContent : el.className;
    }).join('\n');
  }

  function groupBundleOptions(root) {
    if (root.getAttribute('data-kb-sig') === signature(root)) return;
    var wrappers = Array.prototype.filter.call(root.children, function (el) {
      return el.classList.contains('selector-wrapper');
    });
    var groups = [];
    var byName = {};

    wrappers.forEach(function (wrapper) {
      var title = wrapper.querySelector('.bcpo-title');
      if (!title) return;
      var full = title.getAttribute('data-kb-full') || title.textContent.replace(/:\s*$/, '').trim();
      var i = full.indexOf(SEP);
      if (i < 1) return;
      var name = full.slice(0, i);
      if (!byName[name]) {
        byName[name] = [];
        groups.push(name);
      }
      byName[name].push({ wrapper: wrapper, title: title, full: full, label: full.slice(i + SEP.length) });
    });

    if (groups.length < 2) return;

    root.querySelectorAll(':scope > .kb-bundle-group__title').forEach(function (el) { el.remove(); });
    var anchor = root.querySelector(':scope > .bcpo-file-check');

    groups.forEach(function (name) {
      var heading = document.createElement('p');
      heading.className = 'kb-bundle-group__title';
      heading.textContent = name;
      root.insertBefore(heading, anchor);
      byName[name].forEach(function (item) {
        item.title.setAttribute('data-kb-full', item.full);
        item.title.textContent = item.label + ':';
        root.insertBefore(item.wrapper, anchor);
      });
    });
    root.classList.add('kb-bundle');
    root.setAttribute('data-kb-sig', signature(root));
  }

  // VO Product Options hardcodes its dropdown placeholder in English. Swap it for
  // the page language (all products, not only bundles); idempotent.
  var PLACEHOLDERS = { fi: 'Valitse', sv: 'Välj' };
  function localizePlaceholders(root) {
    var text = PLACEHOLDERS[(document.documentElement.lang || '').slice(0, 2)];
    if (!text) return;
    root.querySelectorAll('select option[value=""]').forEach(function (option) {
      if (option.textContent.trim() === 'Choose one') option.textContent = text;
    });
  }

  // The studs + pendant set picks its diamond shape with a VO dropdown (a virtual
  // option, since the product already uses Shopify's three options). Show it as
  // icon-only shape buttons instead (the name shows after the label), first in the list; the hidden dropdown keeps the
  // value, so VO's required check and the order line property still work.
  var SHAPES = {
    Round: '<circle cx="12" cy="12" r="9"/><path d="M12 7.5l3.2 1.3 1.3 3.2-1.3 3.2-3.2 1.3-3.2-1.3-1.3-3.2 1.3-3.2z"/><path d="M12 3v4.5M21 12h-4.5M12 21v-4.5M3 12h4.5M5.6 5.6l3.2 3.2M18.4 5.6l-3.2 3.2M18.4 18.4l-3.2-3.2M5.6 18.4l3.2-3.2"/>',
    Pear: '<path d="M12 2.5C8.6 7.4 5.5 11.2 5.5 15a6.5 6.5 0 0 0 13 0c0-3.8-3.1-7.6-6.5-12.5z"/><path d="M12 8.5c-1.8 2.6-3.3 4.6-3.3 6.5a3.3 3.3 0 0 0 6.6 0c0-1.9-1.5-3.9-3.3-6.5z"/>',
    Emerald: '<path d="M8.5 3h7L18 5.5v13L15.5 21h-7L6 18.5v-13z"/><path d="M10 7h4l1 1v8l-1 1h-4l-1-1V8z"/><path d="M8.5 3l1.5 4M15.5 3L14 7M18 5.5L15 8M18 18.5L15 16M15.5 21L14 17M8.5 21l1.5-4M6 18.5L9 16M6 5.5L9 8"/>'
  };
  var SHAPE_LABELS = {
    fi: { Round: 'Pyöreä', Pear: 'Pisara', Emerald: 'Smaragdi' },
    sv: { Round: 'Rund', Pear: 'Droppe', Emerald: 'Emerald' }
  };
  function shapeButtons(root) {
    var lang = (document.documentElement.lang || '').slice(0, 2);
    var labels = SHAPE_LABELS[lang] || {};
    root.querySelectorAll(':scope > .selector-wrapper select').forEach(function (select) {
      var values = Array.prototype.map.call(select.options, function (o) { return o.value; }).filter(Boolean);
      if (!values.length || values.some(function (v) { return !SHAPES[v]; })) return;
      var wrapper = select.closest('.selector-wrapper');
      var valueEl = wrapper.querySelector('.bcpo-value');
      var row = wrapper.querySelector('.kb-shape__row');
      if (!row) {
        wrapper.classList.add('kb-shape');
        select.parentElement.classList.add('kb-shape__select');
        row = document.createElement('div');
        row.className = 'kb-shape__row';
        values.forEach(function (v) {
          var button = document.createElement('button');
          button.type = 'button';
          button.className = 'kb-shape__btn';
          button.setAttribute('data-value', v);
          button.setAttribute('aria-label', labels[v] || v);
          button.title = labels[v] || v;
          button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' + SHAPES[v] + '</svg>';
          button.addEventListener('click', function () {
            select.value = v;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            sync();
          });
          row.appendChild(button);
        });
        select.parentElement.parentElement.insertBefore(row, select.parentElement);
        select.addEventListener('change', sync);
      }
      function sync() {
        row.querySelectorAll('.kb-shape__btn').forEach(function (b) {
          var on = b.getAttribute('data-value') === select.value;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        if (valueEl) valueEl.textContent = select.value ? (labels[select.value] || select.value) : '';
      }
      sync();
      var first = root.querySelector(':scope > .selector-wrapper, :scope > .kb-bundle-group__title');
      if (first !== wrapper) root.insertBefore(wrapper, first);
    });
  }

  var scheduled = false;
  function run() {
    scheduled = false;
    var root = document.getElementById('bcpo');
    if (!root) return;
    localizePlaceholders(root);
    if (root.getAttribute('data-kb-sig') === signature(root)) return;
    shapeButtons(root);
    groupBundleOptions(root);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(run, 0);
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (t.id === 'bcpo' || (t.closest && t.closest('#bcpo')) || (t.querySelector && t.querySelector('#bcpo'))) {
        schedule();
        return;
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
